import React, { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { Button, Col, Container, Input, InputGroup, Row } from "reactstrap";
import './Supporttickets.css';
import Previous_support_card from "./Previous_support_card";

function Previous_Support_Tickets({ previousTickets, handleEditClick }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const handleStatusClick = (status) => {
    setStatusFilter(status);
  };

  const filteredTickets = previousTickets?.filter((ticket) => {
    const searchString = JSON.stringify(ticket).toLowerCase();
    const matchSearch = searchString.includes(searchTerm.toLowerCase());

    const matchStatus = statusFilter === "all"
      ? true
      : ticket.status?.toLowerCase() === statusFilter;

    return matchSearch && matchStatus;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col style={{ padding: "50px 0px" }} xs="12" md="6">
          <h1 style={{ fontSize: "24px", fontWeight: 700 }}>Previous Support Tickets</h1>
        </Col>

        <Col xs="12" md="6" className="d-flex justify-content-md-end">
          <InputGroup style={{ maxWidth: "320px", height: "40px", borderRadius: "8px" }}>
            <Input
              placeholder="Search ticket here..."
              style={{ fontSize: "14px" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button className="stbtn" style={{ backgroundColor: "white", border: "1px solid #E5E5E5" }}>
              <FiSearch style={{ fontSize: "14px", color: "#B7B7B7 " }} />
            </Button>
          </InputGroup>
        </Col>
      </Row>

      {/* Filter Tabs Styled Like Yours */}
      <div className="tabs">
        {["all", "open", "reopen", "closed"].map((status) => (
          <div
            key={status}
            className={`tab-item ${statusFilter === status ? "active" : ""}`}
            onClick={() => handleStatusClick(status)}
            style={{ cursor: "pointer", textTransform: "capitalize" }}
          >
            {status}
          </div>
        ))}
      </div>

      {/* Tickets */}
      <Row style={{ padding: "30px 0px" }}>
        {filteredTickets?.length > 0 ? (
          filteredTickets.map((ticket, index) => (
            <Col key={index} sm={12} xxl={4} xl={6}>
              <Previous_support_card ticket={ticket} handleEditClick={handleEditClick} />
            </Col>
          ))
        ) : (
          <p>No tickets found.</p>
        )}
      </Row>
    </Container>
  );
}

export default Previous_Support_Tickets;
